import * as ACTIONS from '../actions/authentication';

const initialState = {
  accessToken: '',
  client: '',
  errors: [],
  loggedIn: false,
  user: null,
  accounts: [],
};

export default function authenticationReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.AUTHENTICATION_SUCCESS:
      return {
        ...state,
        accessToken: action.payload.accessToken,
        client: action.payload.client,
        errors: [],
        loggedIn: true,
        user: action.payload.user,
        enterpriseRedirect: action.payload.enterpriseRedirect,
      };

    case ACTIONS.AUTHENTICATION_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };

    case ACTIONS.AUTHENTICATION_LOGOUT:
      return {
        ...state,
        accessToken: '',
        client: '',
        loggedIn: false,
        user: null,
      };

    case ACTIONS.AUTHENTICATION_ACCOUNTS_SET:
      return {
        ...state,
        accounts: action.payload,
      };

    case ACTIONS.CANCEL_ENTERPRISE_REDIRECT:
      return {
        ...state,
        enterpriseRedirect: false,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authentication.js